module.exports = __webpack_public_path__ + "img/tiee.c51fb45b.svg";